var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
document.addEventListener("DOMContentLoaded", () => {
  if (!document.querySelector('[href="/users/sign_out"]')) {
    return;
  }
  const STORAGE_KEY = "awesome_voting_cards_hide_modal";
  const MODAL_ID = "voting-cards-help-modal";
  const getStorage = () => JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  const saveStorage = (key, val) => localStorage.setItem(STORAGE_KEY, JSON.stringify(__spreadProps(__spreadValues({}, getStorage()), { [key]: val })));
  const findContainer = (el) => el.closest(".awesome-voting-card[data-proposal-id], .voting-voting_cards[data-proposal-id]");
  const isModalOpen = () => {
    var _a;
    return (_a = window.Decidim.currentDialogs[MODAL_ID]) == null ? void 0 : _a.isOpen;
  };
  const modal = document.querySelector(`[data-dialog="${MODAL_ID}"]`);
  if (!modal) {
    return;
  }
  const voteCard = modal.querySelector(".current-choice .vote-card");
  const checkbox = modal.querySelector('[id^="voting_cards-skip_help"]');
  if (!voteCard || !checkbox) {
    return;
  }
  const updateCard = (action) => {
    voteCard.className = "vote-card";
    action.classList.forEach((cls) => voteCard.classList.add(cls));
    let content = "";
    if (action.children.length > 1) {
      const child = action.children[1];
      content = `${child.outerHTML}<span class="vote-label">${child.children[0].textContent}</span>`;
    } else if (voteCard.classList.contains("button")) {
      voteCard.classList.remove("button");
      content = `<span class="vote-label">${action.title}</span>`;
    } else {
      content = `<span class="vote-label">${action.textContent}</span>`;
    }
    voteCard.innerHTML = content;
  };
  checkbox.addEventListener("change", () => saveStorage(checkbox.value, checkbox.checked));
  modal.querySelector(".vote-action").addEventListener("click", () => {
    if (!modal.storedAction) {
      return;
    }
    const container = findContainer(modal.storedAction);
    if (container) {
      container.classList.add("loading");
    }
    modal.storedAction.click();
    setTimeout(() => {
      var _a;
      return (_a = window.Decidim.currentDialogs[MODAL_ID]) == null ? void 0 : _a.close();
    });
  });
  document.body.addEventListener("click", (evt) => {
    const voteAction = evt.target.closest(".awesome-voting-card .vote-action");
    if (!voteAction || voteAction.hasAttribute("data-dialog-open")) {
      return;
    }
    const container = findContainer(voteAction);
    if (!container) {
      return;
    }
    const shouldShow = !getStorage()[checkbox.value] && !isModalOpen();
    if (shouldShow) {
      evt.stopPropagation();
      evt.preventDefault();
      modal.storedAction = voteAction;
      checkbox.checked = false;
      updateCard(voteAction);
      window.Decidim.currentDialogs[MODAL_ID].open();
    } else {
      container.classList.add("loading");
    }
  });
});
